import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaTools, FaHammer, FaMusic, FaCheckCircle, FaPhone } from 'react-icons/fa'; // Ícones para Conserto de Cravelhas
import { LuPiano } from "react-icons/lu";
import SeoHead from "../../components/Menu/components/SeoHead";
import '../../assets/css/consertocravelhas.css'; // CSS específico para esta página

const ConsertoCravelhas = () => {

  const galleryImages = [
  { 
    id: 1, 
    src: '/img/cravelha/1.jpg', 
    alt: 'Retirada das cordas para manutenção das crevelhas' 
  },
  { 
    id: 2, 
    src: '/img/cravelha/2.jpg', 
    alt: 'Retirada das cordas para manutenção das crevelhas' 
  },
  { 
    id: 3, 
    src: '/img/cravelha/3.jpg', 
    alt: 'Cravelhas novas' 
  },
  { 
    id: 4, 
    src: '/img/cravelha/4.jpg', 
    alt: 'Cravelhas calçadas' 
  },
];

const cravelhasSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Conserto e Troca de Cravelhas de Piano",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Waldir Pianos",
    "image": "https://pianoswaldir.com.br/images/logo.jpg"
  },
  "description": "Serviço especializado em conserto e troca de cravelhas de piano para restaurar a capacidade de afinação do instrumento. Inclui calçamento e substituição de cravelhas.",
  "areaServed": {
    "@type": "AdministrativeArea",
    "name": "São Paulo"
  },
  "url": "https://pianoswaldir.com.br/cravelhas"
};


  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  // Auto-rotatividade das imagens
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isHovered) {
        setCurrentImageIndex((prevIndex) => 
          (prevIndex + 1) % galleryImages.length
        );
      }
    }, 5000); // Muda a cada 5 segundos
    
    return () => clearInterval(interval);
  }, [isHovered]);

  const currentImage = galleryImages[currentImageIndex];

  return (
    <div className="conserto-cravelhas-container">
      <SeoHead
  title="Conserto e Troca de Cravelhas de Piano | Waldir Pianos"
  description="Restaure a afinação perfeita do seu piano com nosso serviço de conserto e troca de cravelhas. Técnicas de calçamento e substituição para precisão duradoura."
  keywords="conserto cravelhas piano, troca cravelhas piano, afinação piano, cravelha piano, cêpo piano, Waldir Pianos"
  image="/img/cravelhas/1.jpg" /* Exemplo de caminho de imagem */
  url="https://pianoswaldir.com.br/cravelhas"
  canonicalUrl="https://pianoswaldir.com.br/cravelhas"
  schemaMarkup={cravelhasSchema}
/>
      {/* Cabeçalho */}
      <motion.header
        className="conserto-cravelhas-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="conserto-cravelhas-header-content">
          <motion.h1
            className="conserto-cravelhas-main-title"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <FaTools className="conserto-cravelhas-title-icon" />
            Conserto das Cravelhas
            <span className="conserto-cravelhas-title-decoration"></span>
          </motion.h1>

          <motion.p
            className="conserto-cravelhas-header-subtitle"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            A chave para uma afinação duradoura
          </motion.p>
        </div>
      </motion.header>

      {/* Conteúdo Principal */}
      <div className="conserto-cravelhas-main-content">
        {/* Seção de Texto */}
        <motion.section
          className="conserto-cravelhas-text-section"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
        >
          <motion.div
            className="conserto-cravelhas-text-content"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          >
            <h2 className="conserto-cravelhas-section-title">
              <FaMusic className="conserto-cravelhas-section-icon" />
              A Importância das Cravelhas
            </h2>

            <p className="conserto-cravelhas-classic-text">
              "As cravelhas em um piano têm uma função crucial relacionada ao processo de afinação do instrumento. Fixadas à placa de madeira, conhecida como cêpo, as cravelhas são pinos metálicos que ajustam a tensão das cordas as esticando ou afrouxando quando rotacionadas."
            </p>

            <div className="conserto-cravelhas-modern-text">
              <p>Com o tempo de uso, as cravelhas tendem a afrouxarem devido a dilatação dos buracos onde são fixadas no cepo, passando assim a comprometer o tensão total das cordas e por conseqüência a afinação do instrumento. Neste momento é necessária a manutenção total do sistema de cravelhas que pode ser feita de duas formas:</p>

              <h3>Calçamento das Cravelhas</h3>
              <p>Técnica utilizada para correção da leve dilatação dos furos. Neste procedimento todas as cravelhas são retiradas e recolocadas nos furos acompanhadas de uma fina folha de marfim para calçar o vão causado pela dilatação fazendo com que voltem a ficarem fixadas justas no cepo. Esta técnica mentem as peças originais do instrumento e é uma alternativa mais econômica em relação à substituição total das cravelhas e garante um resultado bastante satisfatório que pode durar em média de 10 a 15 anos com uso moderado até a próxima manutenção.</p>

              <h3>Troca das Cravelhas</h3>
              <p>Quando a dilatação dos furos do cepo atingem um diâmetro que o calçamento não consegue mais atender, a solução para recuperar a capacidade das cravelhas tensionarem adequadamente as cordas e substitui-las por outras alguns milímetros mais grossas. Esta técnica, embora tenha maior custo, garante um resultado de maior duração, em torno de 20 a 30 anos com uso moderado, além de valorizar bastante o aspecto visual com cravelhas novas e brilhantes.</p>

              <p>Em ambos os serviços é necessário o desencordoamento total do piano para a recuperação da capacidade do instrumento de segurar afinação adequada.</p>
            </div>

            <div className="conserto-cravelhas-benefits-grid">
              <div className="conserto-cravelhas-benefit-item">
                <FaHammer className="conserto-cravelhas-benefit-icon" />
                <span>Restauração da fixação das cravelhas</span>
              </div>
              <div className="conserto-cravelhas-benefit-item">
                <FaTools className="conserto-cravelhas-benefit-icon" />
                <span>Melhora significativa na afinação</span>
              </div>
              <div className="conserto-cravelhas-benefit-item">
                <FaCheckCircle className="conserto-cravelhas-benefit-icon" />
                <span>Duas opções de serviço: Calçamento ou Troca</span>
              </div>
            </div>
          </motion.div>
        </motion.section>

        {/* Galeria (Opcional - Placeholder se não houver imagens específicas) */}
       <motion.section
        className="armazenagem-gallery-section"
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.7 }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <h3 className="armazenagem-gallery-title">Conserto das Cravelhas</h3>
        
        <motion.div 
          className="armazenagem-gallery-container"
          key={currentImageIndex}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <div className="armazenagem-piano-image">
            <img 
              src={currentImage.src} 
              alt={currentImage.alt}
              className="armazenagem-gallery-image"
            />
            <div className="armazenagem-image-overlay">
              <span className="armazenagem-piano-description">
                {currentImage.alt}
              </span>
            </div>
          </div>
        </motion.div>
        
        {/* Pontos de navegação */}
        <div className="armazenagem-gallery-dots">
          {galleryImages.map((_, index) => (
            <button
              key={index}
              className={`armazenagem-dot ${index === currentImageIndex ? 'armazenagem-dot-active' : ''}`}
              onClick={() => setCurrentImageIndex(index)}
            />
          ))}
        </div>
      </motion.section>
      </div>

      {/* Rodapé */}
      <motion.footer
        className="conserto-cravelhas-footer"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
      >
        <p className="conserto-cravelhas-footer-text">Seu piano precisa de uma afinação estável?</p>
        <motion.a
          href="tel:1122565987"
          className="conserto-cravelhas-contact-button"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <FaPhone /> Fale Conosco
        </motion.a>
      </motion.footer>
    </div>
  );
};

export default ConsertoCravelhas;